import { render } from "./TextItemV2.vue?vue&type=template&id=8cf5fba4&scoped=true"
import script from "./TextItemV2.vue?vue&type=script&lang=js"
export * from "./TextItemV2.vue?vue&type=script&lang=js"

import "./TextItemV2.vue?vue&type=style&index=0&id=8cf5fba4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cf5fba4"],['__file',"src/containers/popup/components/TextItemV2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8cf5fba4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8cf5fba4', __exports__)) {
    api.reload('8cf5fba4', __exports__)
  }
  
  module.hot.accept("./TextItemV2.vue?vue&type=template&id=8cf5fba4&scoped=true", () => {
    api.rerender('8cf5fba4', render)
  })

}


export default __exports__